module.exports = "<backup-schedules-page></backup-schedules-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/backupSchedules.html
// module id = 1802
// module chunks = 0